/**
 * Volba barevneho pozadi. Stejne mapovani je i v inline skriptu v index.html,
 * ktery pozadi nastavi uz pred prvnim vykreslenim.
 */
export const BACKGROUNDS = [
  { id: 'zapad', label: 'Západ slunce' },
  { id: 'laguna', label: 'Laguna' },
  { id: 'boruvka', label: 'Borůvka' },
] as const

export type BackgroundId = (typeof BACKGROUNDS)[number]['id']

const STORAGE_KEY = 'sp:pozadi'

/** Zakladni barva pod skvrnami — pro listu systemu (theme-color). */
const BASE: Record<BackgroundId, { light: string; dark: string }> = {
  zapad: { light: '#fbf1ea', dark: '#110d17' },
  laguna: { light: '#eef7f5', dark: '#071214' },
  boruvka: { light: '#f3f0fb', dark: '#0e0c1c' },
}

function isBackground(value: unknown): value is BackgroundId {
  return BACKGROUNDS.some((b) => b.id === value)
}

export function currentBackground(): BackgroundId {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return isBackground(stored) ? stored : 'zapad'
  } catch {
    return 'zapad'
  }
}

export function applyBackground(id: BackgroundId): void {
  try {
    localStorage.setItem(STORAGE_KEY, id)
  } catch {
    // Bez localStorage plati volba jen do zavreni stranky.
  }
  document.documentElement.dataset['bg'] = id
  const dark = window.matchMedia('(prefers-color-scheme: dark)').matches
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', BASE[id][dark ? 'dark' : 'light'])
}
